import { DialogProps } from "../misc/DialogProps";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import { SelectCourseTypeForm } from "./CreateCourseDialog/SelectCourseTypeForm";
import { TheoryCourseWizard } from "./CreateCourseDialog/TheoryCourseWizard";
import { ASFCourseWizard } from "./CreateCourseDialog/ASFCourseWizard";
import { CreateBKFCourseForm } from "./CreateCourseDialog/CreateBKFCourseForm";
import { type CourseTemplate } from "../providers/courseTemplatesProvider";
import { useDraggableDialog } from "../hooks/useDraggableDialog";
import { CreateTheoryLessonForm } from "./AddAppointmentDialog/CreateTheoryLessonForm";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

export function CreateCourseDialog(props: DialogProps) {
  const { onClose } = props;
  const [state, setState] = useState<
    "selectCourseType" | "createTheoryCourse" | "createB96Course" | "createASFCourse" | "createBKFCourse"
  >("selectCourseType");
  const [courseTemplate, setCourseTemplate] = useState<CourseTemplate | undefined>();
  const { dialogOffset, onTitleMouseDown } = useDraggableDialog({ open: props.open });

  return (
    <Dialog
      {...props}
      maxWidth={state === "createTheoryCourse" || state === "createASFCourse" ? false : "sm"}
      fullWidth={state !== "createTheoryCourse" && state !== "createASFCourse"}
      BackdropProps={{
        sx: {
          backgroundColor: "transparent",
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
        },
      }}
      PaperProps={{
        sx: {
          width: state === "createTheoryCourse" || state === "createASFCourse" ? "1100px" : undefined,
          transform: `translate(${dialogOffset.x}px, ${dialogOffset.y}px)`,
        },
      }}
    >
      <DialogTitle
        onMouseDown={onTitleMouseDown}
        sx={{
          cursor: "move",
          userSelect: "none",
          marginRight: 0,
          paddingRight: "80px",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
      >
        {state === "createTheoryCourse"
          ? "Neuer Theoriekurs"
          : state === "createB96Course"
            ? "Neue Theoriestunde"
            : state === "createASFCourse"
              ? "Neuer ASF Kurs"
              : "Neuer Kurs"}
      </DialogTitle>
      <DialogCloseButton onClick={onClose} />
      {state === "selectCourseType" && (
        <SelectCourseTypeForm
          createTheoryCourse={() => setState("createTheoryCourse")}
          createB96Course={() => setState("createB96Course")}
          createASFCourse={() => setState("createASFCourse")}
          createBKFCourse={(courseTemplate) => {
            setState("createBKFCourse");
            setCourseTemplate(courseTemplate);
          }}
        />
      )}
      {state === "createTheoryCourse" && (
        <TheoryCourseWizard goBack={() => setState("selectCourseType")} onSuccess={props.onClose} />
      )}
      {state === "createB96Course" && (
        <DialogContent>
          <CreateTheoryLessonForm
            initialLecture="B96"
            backButton={
              <Button
                startIcon={<NavigateBeforeIcon />}
                variant="outlined"
                onClick={() => setState("selectCourseType")}
              >
                Zurück
              </Button>
            }
            onSuccess={props.onClose}
          />
        </DialogContent>
      )}
      {state === "createASFCourse" && (
        <ASFCourseWizard goBack={() => setState("selectCourseType")} onSuccess={props.onClose} />
      )}
      {state === "createBKFCourse" && courseTemplate && (
        <CreateBKFCourseForm
          initialCourseTemplate={courseTemplate}
          goBack={() => setState("selectCourseType")}
          onSuccess={props.onClose}
        />
      )}
    </Dialog>
  );
}
